import { useEffect, useState } from 'react';
import { API } from '@unboared/react';
import { Avatar } from '~/components/design/avatar';
import styles from './QRCodeView2.module.css';

export type AnimatedAvatarProps = {
    gamepadID: string;
    containerRef: React.RefObject<HTMLDivElement>;
};

export function AnimatedAvatar({ containerRef, gamepadID }: AnimatedAvatarProps) {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [lastEdge, setLastEdge] = useState<string | null>(null);
    const [speed, setSpeed] = useState(2000); // Default speed in ms
    const src = API.getAvatar(gamepadID);
    const color = API.getColor(gamepadID);
    const name = API.getUsername(gamepadID);

    const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1) + min);

    const getRandomEdgePosition = (width: number, height: number, previousEdge: string | null) => {
        const edges = ['right', 'left', 'top', 'bottom'];
        const availableEdges = previousEdge ? edges.filter((edge) => edge !== previousEdge) : edges;
        const selectedEdge = availableEdges[Math.floor(Math.random() * availableEdges.length)];

        switch (selectedEdge) {
            case 'top':
                return { x: getRandomInt(-width / 2 + 60, width / 2), y: -height / 2 + 30, edge: selectedEdge };
            case 'right':
                return { x: width / 2, y: getRandomInt(-height / 2 + 30, height / 2 - 30), edge: selectedEdge };
            case 'bottom':
                return { x: getRandomInt(-width / 2 + 60, width / 2), y: height / 2 - 30, edge: selectedEdge };
            case 'left':
                return { x: -width / 2 + 60, y: getRandomInt(-height / 2 + 30, height / 2 - 30), edge: selectedEdge };
            default:
                return { x: 0, y: 0, edge: null };
        }
    };

    const calculateDistance = (x1: number, y1: number, x2: number, y2: number) =>
        Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));

    useEffect(() => {
        const moveAvatar = () => {
            if (!containerRef.current) return;
            const { width, height } = containerRef.current.getBoundingClientRect();
            const newPosition = getRandomEdgePosition(width, height, lastEdge);
            const distance = calculateDistance(position.x, position.y, newPosition.x, newPosition.y);
            const newSpeed = distance * 5; // Example: 2ms per pixel of distance

            setPosition({ x: newPosition.x, y: newPosition.y });
            setLastEdge(newPosition.edge);
            setSpeed(newSpeed);
        };

        const intervalId = setInterval(moveAvatar, speed);
        return () => clearInterval(intervalId);
    }, [containerRef, lastEdge, position]);

    useEffect(() => {
        const moveAvatar = () => {
            if (!containerRef.current) return;
            const { width, height } = containerRef.current.getBoundingClientRect();
            const newPosition = getRandomEdgePosition(width, height, lastEdge);
            const distance = calculateDistance(position.x, position.y, newPosition.x, newPosition.y);
            const newSpeed = distance * 2; // Example: 2ms per pixel of distance

            setPosition({ x: newPosition.x, y: newPosition.y });
            setLastEdge(newPosition.edge);
            setSpeed(newSpeed);
        };

        moveAvatar();
    }, [containerRef]);

    return (
        <div className={styles.unguyBox}>
            {color && src && (
                <Avatar
                    src={src}
                    name={name}
                    color={color}
                    className={styles.unguy}
                    style={{
                        transform: `translate(${position.x}px, ${position.y}px)`,
                        transition: `transform ${speed}ms ease-in-out`,
                    }}
                    body
                />
            )}
        </div>
    );
}
